import React from 'react';

const DownloadMedium = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
        <path d="M8.5 13.0428V1.70947" stroke="white" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.1659 14.4595H2.83252" stroke="white" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.1659 7.37549L8.49919 13.0422L2.83252 7.37549" stroke="white" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default DownloadMedium;
